export default {"src":"/_next/static/media/3lbs.cf6adad7.svg","height":132,"width":180,"blurWidth":0,"blurHeight":0};